import React, {useState, useEffect, useRef} from 'react';
import {Link, generatePath} from 'react-router-dom';
import routes from 'globals/routes';
import './projectWrapper.css';
import { useDataValue } from 'globals/contexts/dataContext';
const getImageDimension = async (url)  => {
  const tmpImg = new Image();
  const imageDiemnsion = await new Promise((resolve, reject) => {
    tmpImg.onload = () => {
      resolve([
        tmpImg.width,
        tmpImg.height
      ]);
    }
    tmpImg.onerror = () => {
      reject("Fail to load the image");
    }
    tmpImg.src = url;
  });

  return imageDiemnsion;
}
const ProjectWrapper = ({items, selectedFilter, ProjectInfoRenderer, onProjectClick, colOffestTop}) => {
  const [colCount, setColCount] = useState(2);
  const [colGap, setColGap] = useState(window.innerWidth / 50);
  const [colWidth, setColWidth] = useState(0);
  const [projectsStatus, setProjectsStatus] = useState([]);
  const [projectsPosition, setProjectsPosition] = useState([]);
  const itemsWrapper = useRef(null);
  const updateFramerate = useRef(null);
  const updateFramerate2 = useRef(null);
  const itemsRef = useRef([]);
  const [{currentLanguage}] = useDataValue();

  const updateWrapperWidth = () => {
    if (updateFramerate.current) {
      cancelAnimationFrame(updateFramerate.current);
    }
    if (updateFramerate2.current) {
      clearTimeout(updateFramerate2.current);
    }
    updateFramerate.current = requestAnimationFrame(() => {
      if (itemsWrapper.current) {
        let colGap = window.innerWidth / 50;
        let colCount = 2;
        if (window.innerWidth < 768) {
          colCount = 1;
          colGap = 75;
        }
        setColWidth((itemsWrapper.current.offsetWidth - colGap * (colCount - 1)) / colCount);
        setColCount(colCount);
        if (updateFramerate2.current) {
          clearTimeout(updateFramerate2.current);
        }
        setTimeout(() => {
          setColGap(colGap);
        }, 400);
      }
    })
  };

  useEffect(() => {
    window.addEventListener('resize', updateWrapperWidth);
    setTimeout(updateWrapperWidth, 400);
    return () => {
      window.removeEventListener('resize', updateWrapperWidth);
    }
  }, [])
  useEffect(() => {
    let unmount = false;
    (async function fetchImages () {
      const newStatus = [];
      for (let i = 0; i < items.length; i++) {
        await (async project => {
          const imageDiemnsion = await getImageDimension(project['thumb']);
          const status = {
            project: project,
            filter: project['type'],
            width: imageDiemnsion[0],
            height: imageDiemnsion[1],
            visible: false
          };
          newStatus.push(status);
        })(items[i]);
      }
      if (!unmount) {
        setProjectsStatus(newStatus);
      }
    })();
    return () => {
      unmount = true;
    }
  }, [items]);
  useEffect(() => {
    if (projectsStatus.length) {
      const newProjectsPosition = [];
      const columnHeight = new Array(colCount).fill(0);
      if (colOffestTop) {
        for (let i = 0; i < colCount; i++) {
          if (colOffestTop[i]) {
            columnHeight[i] = colOffestTop[i];
          }
        }
      }
      // colOffestTop
      projectsStatus.forEach((projectStatus, idx) => {
        const projectPosition = {};
        if (selectedFilter === null || projectStatus['project']['type'] === selectedFilter) {
          const indexColumnHeightMin = columnHeight.indexOf(Math.min(...columnHeight));
          projectPosition['top'] = columnHeight[indexColumnHeightMin];
          projectPosition['left'] = indexColumnHeightMin * (colWidth  + colGap);
          itemsRef.current[idx].style.left = projectPosition['left'] + 'px';
          itemsRef.current[idx].style.top = projectPosition['top'] + 'px';
          itemsRef.current[idx].style.width = colWidth + 'px';
          columnHeight[indexColumnHeightMin] += 
            itemsRef.current[idx].offsetHeight + colGap * 1;
            // projectStatus['height'] * colWidth / projectStatus['width'] + // image
            // (projectStatus['project']['caption']? Math.ceil(projectStatus['project']['caption'].length / 90) * colGap: 0) + // caption
            // colGap * 1.5;
        } else {
          projectPosition['top'] = projectsPosition[idx]? projectsPosition[idx]['top']: 0;
          projectPosition['left'] = projectsPosition[idx]? projectsPosition[idx]['left']: 0;
        }
        newProjectsPosition.push(projectPosition);
      })
      itemsWrapper.current.style.height = `${Math.max(...columnHeight)}px`;
      setProjectsPosition(newProjectsPosition);
    }
  }, [colWidth, colGap, projectsStatus, selectedFilter]);

  useEffect(() => {
    updateWrapperWidth();
  }, [projectsPosition])
  return <div className="projectWrapper" ref={itemsWrapper}>
  {items.map((project, idx) => {
    {/* console.log('item - ' + idx); */}
    return <div
      // to={generatePath(routes.commercialProjectPage, {lang: currentLanguage, project: project['id']})}
      className={`projectItem${selectedFilter && selectedFilter !== project['type']? " hide": ""}`} 
      key={project['id']? project['id']: idx}
      // style={{
      //   top: projectsPosition[idx]['top'],
      //   left: projectsPosition[idx]['left'],
      //   width: colWidth,
      // }}
      ref={ref => itemsRef.current[idx] = ref}
      onClick={() => {
        if (onProjectClick) {
          onProjectClick(project['id']);
        }
      }}
    >
      <div className="projectImage">
        <img src={project['thumb']} />
      </div>
      <ProjectInfoRenderer key={project['id']} project={project}/>
    </div>;
  })}
</div>
}

export default ProjectWrapper;